<template>
  <div>
    <template v-for="(note,index) in notes">
      <note-card
        v-test-id="'note-card'"
        :linkable-title="isListMode"
        :truncate-body="truncateAllNotes"
        :editable="!note.is_locked && note.creator.username === loggedInUsername"
        @edit-note-click="$emit('edit-note-click', note)"
        @title-click="$emit('note-click', note)"
        @mouseover.native="onMouseOver(index)"
        :showActions="showActions && hoveredCardIndex === index"
        :key="note.id"
        v-bind="getNoteProps(note)"
        :data-element="`note-${index}`"
      >
        <template #note-breadcrumb>
          <slot
            name="note-breadcrumb"
            v-bind="{note}"
          >
          </slot>
        </template>

        <template #note-subtitle>
          <slot
            name="note-subtitle"
            v-bind="{note}"
          />
        </template>
      </note-card>
      <hr
        :key="`_${index}`"
        class="u-m0">
    </template>
    <div v-if="!(isFetching || notes.length)">
      <p class="u-p3 u-text--light u-text--center">There are no notes yet.</p>
    </div>
    <bc-infinite-scroll-pagination
      v-if="currentPagination"
      @scrollEnd="atScrollEnd"
      :isLoading="isFetching"
      :currentPage="currentPagination.currentPage"
      :nextPage="currentPagination.nextPage">
      <div class="l-flex-grid l-flex-grid--h-center u-p3">
        <p
          v-if="notes.length"
          class="u-full u-text--light u-text--center">
          There are no more notes
        </p>
        <el-button
          @click="$emit('refresh-notes')"
          type="primary"
          size="mini">
          Refresh
        </el-button>
      </div>
    </bc-infinite-scroll-pagination>
  </div>
</template>

<script>
import {mapState, mapGetters, mapMutations} from 'vuex'
import notesMutations from '#/notes/store/mutationTypes'
import NoteCard from '#/notes/components/NoteCard'
import {NotesMixins} from '#/notes/components/mixins'
import InfiniteScrollPagination from '#/notes/components/InfiniteScrollPagination'

export default {
  name: 'NotesList',
  mixins: [NotesMixins],
  components: {
    NoteCard,
    [InfiniteScrollPagination.name]: InfiniteScrollPagination
  },
  created () {
    this.loggedInUsername = this.userService.fetchLoggedInUsername()
  },
  data () {
    return {
      hoveredCardIndex: null,
      username: null
    }
  },
  props: {
    truncateAllNotes: {
      type: Boolean,
      default: true
    },
    notes: {
      type: Array,
      default: () => []
    },
    showActions: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState('notes', [
      'currentPagination',
      'isFetching'
    ]),
    ...mapGetters('notes', [
      'isListMode',
      'userService'
    ])
  },
  methods: {
    ...mapMutations({
      updatePagination: notesMutations.UPDATE_PAGINATION
    }),
    onMouseOver (index) {
      this.hoveredCardIndex = index
    },
    atScrollEnd ({currentPage}) {
      this.updatePagination({
        currentPage
      })
      this.$emit('scrollEnd')
    }
  }
}
</script>
